exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-testDetails-ExportTestCard-exportButton{width:100% !important;color:#fff !important;border:none !important;border-radius:0 !important;background-color:#1a3142 !important;white-space:normal !important}.src-components-testDetails-ExportTestCard-pdfIcon:before{content:\"\\F1C1\"}.src-components-testDetails-ExportTestCard-chartIcon:before{content:\"\\F080\"}.src-components-testDetails-ExportTestCard-csvIcon:before{content:\"\\F0CE\"}.src-components-testDetails-ExportTestCard-txtIcon:before{content:\"\\F15C\"}", ""]);

// exports
exports.locals = {
	"exportButton": "src-components-testDetails-ExportTestCard-exportButton",
	"pdfIcon": "src-components-testDetails-ExportTestCard-pdfIcon",
	"chartIcon": "src-components-testDetails-ExportTestCard-chartIcon",
	"csvIcon": "src-components-testDetails-ExportTestCard-csvIcon",
	"txtIcon": "src-components-testDetails-ExportTestCard-txtIcon"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/testDetails/ExportTestCard/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/testDetails/ExportTestCard/styles.scss
// module chunks = 1